/*
 * Public API Surface of ngx-lib/checkbox
 */
export * from './checkbox.module';
export * from './checkbox.component';
